"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AuthService = /*#__PURE__*/function () {
  function AuthService() {
    _classCallCheck(this, AuthService);
  }

  _createClass(AuthService, null, [{
    key: "isLoggedIn",
    value: function isLoggedIn() {
      var token = AuthService.getToken();
      return !!token && !AuthService.isTokenExpired(token);
    }
  }, {
    key: "setToken",
    value: function setToken(idToken) {
      if (typeof window !== 'undefined') {
        global.window.localStorage.setItem('id_token', idToken);
      }
    }
  }, {
    key: "setAccessToken",
    value: function setAccessToken(accessToken) {
      if (typeof window !== 'undefined') {
        global.window.localStorage.setItem('access_token', accessToken);
      }
    }
  }, {
    key: "getToken",
    value: function getToken() {
      if (typeof window !== 'undefined') {
        return global.window.localStorage.getItem('id_token');
      }

      return '';
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      if (typeof window !== 'undefined') {
        return global.window.localStorage.getItem('access_token');
      }

      return '';
    }
  }, {
    key: "getTokenExpirationDate",
    value: function getTokenExpirationDate() {
      var token = AuthService.getToken();
      var decoded = AuthService.getDecodedToken(token);

      if (!decoded.exp) {
        return null;
      }

      var date = new Date(0);
      date.setUTCSeconds(decoded.exp);
      return date;
    }
  }, {
    key: "getDecodedToken",
    value: function getDecodedToken(token) {
      return (0, _jwtDecode["default"])(token);
    }
  }, {
    key: "isTokenExpired",
    value: function isTokenExpired() {
      var token = AuthService.getToken();
      if (!token) return true;
      var date = AuthService.getTokenExpirationDate();
      var offsetSeconds = 0;

      if (date === null) {
        return false;
      }

      return !(date.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
    }
  }]);

  return AuthService;
}();

exports["default"] = AuthService;